module.exports = __webpack_public_path__ + "img/space-station-moon-construction.e8333cd8.svg";